import moment from 'moment';

export default class DateFormatter {

  static formatDate(date) {
    if (date){
      return moment(date).format('DD/MM/YYYY');
    }
    return null;
  }

  static formatDatetime(date) {
    if (date){
      return moment(date).format('HH:mm DD/MM/YYYY');
    }
    return null;
  }

  static tryFormatDate(date) {
    if (date){
      if (typeof date === 'string') {
        return date;
      }
      return moment(date).format('DD/MM/YYYY');
    }
    return null;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/utils/DateFormatter.js